import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=ce1f5fe4&"
import script from "./DetailOrder.vue?vue&type=script&lang=ts&"
export * from "./DetailOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Volumes/NVME/projects/vbimex/gubuy/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
installComponents(component, {VLayout})
